module.exports = __webpack_public_path__ + "static/media/Auto.ff68a105.svg";